export default __webpack_public_path__ + "static/media/Increase_the_display_about_200.93191006.svg";